module.exports = __webpack_public_path__ + "img/register.6408f3b0.jpg";